import React from 'react';

import { Alert, Box, List, ListItem, ListItemText, Typography } from '@mui/material';

const MAX_VISIBLE_ERRORS = 20;

interface ErrorAlertsProps {
  title: string;
  errors: Array<string>;
}

export default function ErrorAlerts({ title, errors }: ErrorAlertsProps) {
  if (!errors || errors.length === 0) {
    return null;
  }

  const visibleErrors = errors.slice(0, MAX_VISIBLE_ERRORS);
  const remainingCount = errors.length - MAX_VISIBLE_ERRORS;

  return (
    <Box mb={3}>
      <Alert severity="error">
        <Typography variant="subtitle2" gutterBottom>
          {title}
        </Typography>
        <List dense disablePadding>
          {visibleErrors.map((error, index) => (
            <ListItem key={index} disableGutters sx={{ py: 0 }}>
              <ListItemText primary={error} primaryTypographyProps={{ variant: 'body2' }} />
            </ListItem>
          ))}
          {remainingCount > 0 && (
            <ListItem disableGutters sx={{ py: 0 }}>
              <ListItemText
                primary={`... and ${remainingCount} more errors`}
                primaryTypographyProps={{ variant: 'body2', fontStyle: 'italic' }}
              />
            </ListItem>
          )}
        </List>
      </Alert>
    </Box>
  );
}
